import { Button, Form, message, Modal, Select, Tabs } from "antd";
import React, { useEffect, useState, useRef } from "react";
import {
    DeviceInfo,
    MantraIrisdeviceInfoAvdm,
    MantraPIDOPTS,
    MantradeviceInfoAvdm,
    MorphpoPIDOPTS,
    StartekDeviceInfo,
    ToastContainerMsg,
    aadharPattern,
    captureUrl,
    deviceOptions,
    dispatchtoast,
    filterOption,
    getLocalStorageItem,
    getPosition,
    mantrairisPIDOPTS,
    mobilePattern,
    parseXml,
    setLocalStorageItem,
    startekPIDOPTS,
} from "../../../../../Utils";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { xml2json } from "../../../../../Utils/xml2json";
import {
    AepsAadharpay,
    AepsBalanceEnquiry,
    AepsCashDeposit,
    AepsCashWithdrawl,
    AepsMinistatement,
    AepsTwoFactorAuth,
    getAllAepsMasters,
    MemberProfile,
} from "../../../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import {
    setProfile,
    setselectedTab,
} from "../../../../../Store/B2bslice";
import ReportDrawer from "../../../../../Common/ReportDrawer";
import CommonInput from "../../../../../Common/CommonInput";
import { EditOutlined } from "@ant-design/icons";
import { FaBuilding, FaMoneyCheck, FaPhone } from "react-icons/fa";
import DetailPage from "./UserDetailASave";

const AllInOne = () => {
    const profiledetail = useSelector((state) => state.B2B.profileDetail);
    const location = useLocation();
    const [btnLoading, setBtnLoading] = useState(false);
    const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
    const [OpenModal, setOpenModal] = useState(false);
    const [amount, setamount] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [response, setResponse] = useState({});
    const [txnType, setTxnType] = useState("BE");
    const [activeTab, setActiveTab] = useState("1");
    const [detail, setdetail] = useState(false);
    const [status2fa, setStatus2Fa] = useState(false);
    const [current, setCurrent] = useState(0);
    const [phoneno, setphoneno] = useState();
    const [adharno, setadharno] = useState();
    const [bankname, setbankname] = useState();
    const [fields, setFields] = useState(null);
    const [banks, setBanks] = useState([]);
    const memberServices = useSelector((state) => state.B2B.memberServices);
    const formref = useRef();
    const formrefModal = useRef();
    const [form] = Form.useForm();
    const [formModal] = Form.useForm();
    const [filledData, setFilledData] = useState(null);


    useEffect(() => {
        dispatch(setselectedTab("3"));

        if (!memberServices.includes("8")) {
            navigate("/not-Available");
            return;
        }
        getAllAepsMasters()
            .then((res) => {
                setBanks(
                    res.data.user_banks.map((i) => ({
                        label: i.bank_name,
                        value: i.id,
                        key: i.id,
                    }))
                );
            })
            .catch((err) => console.log(err));
    }, [memberServices]);


    useEffect(() => {
        if (profiledetail.twofa_status != 1) {
            navigate("/banking/aeps");
        }
    }, [])




    const capture = (x, type, port = 11100, values) => {
        setBtnLoading(true);

        axios({
            method: "CAPTURE",
            url:
                values.device === "morpho"
                    ? `https://localhost:${port}/capture`
                    : values.device === "startek"
                        ? "https://localhost:11200/rd/capture"
                        : `https://127.0.0.1:${port}/rd/capture`,
            data:
                values.device === "morpho"
                    ? MorphpoPIDOPTS
                    : values.device === "mantra"
                        ? MantraPIDOPTS
                        : values.device === "startek"
                            ? startekPIDOPTS
                            : mantrairisPIDOPTS,
            headers: {
                "Content-Type": "text/xml",
                Accept: "text/xml",
            },
        })
            .then((response) => {
                const parsed = parseXml(response.data);
                const xmltojson = JSON.parse(xml2json(parsed).replace("undefined", ""));

                if (xmltojson.PidData.Resp.errCode !== "0") {
                    dispatchtoast(
                        `Failed to fetch fingerprint because of ${xmltojson.PidData.Resp.errInfo}`,
                        true
                    );
                    setBtnLoading(false);
                    return;
                }

                dispatchtoast("Fingerprint Captured SuccessFully");

                const {
                    errCode,
                    errInfo,
                    fCount,
                    fType,
                    pCount,
                    iCount,
                    nmPoints,
                    qScore,
                } = xmltojson.PidData.Resp;

                const { dpId, rdsId, rdsVer, mi, mc, dc } =
                    xmltojson.PidData.DeviceInfo;

                const { ci } = xmltojson.PidData.Skey;
                const { Hmac } = xmltojson.PidData;

                const payload = {
                    customer_mobile: getLocalStorageItem("mobile_num"),
                    customer_aadhaar_number: getLocalStorageItem(
                        "customer_aadhaar_number"
                    ),
                    amount: amount,
                    user_bank: getLocalStorageItem("user_bank_value"),
                    user_bank_name: getLocalStorageItem("user_bank_name"),
                    latitude: getLocalStorageItem("latitude"),
                    longitude: getLocalStorageItem("longitude"),
                    device_imei: xmltojson?.PidData?.additional_info
                        ? Array.isArray(xmltojson.PidData.additional_info.Param)
                            ? xmltojson.PidData.additional_info.Param[0]?.value
                            : xmltojson.PidData.additional_info.Param.value
                        : Array.isArray(
                            xmltojson?.PidData?.DeviceInfo?.additional_info?.Param
                        )
                            ? xmltojson.PidData.DeviceInfo.additional_info.Param[0]?.value
                            : xmltojson.PidData.DeviceInfo.additional_info.Param?.value,
                    errCode: errCode || 0,
                    errInfo: errInfo || 0,
                    fCount: fCount || 0,
                    fType:
                        fields === "morpho" || fields === "mantra" || fields === "startek"
                            ? fType || 2
                            : 0,
                    iType:
                        fields === "morpho" || fields === "mantra" || fields === "startek"
                            ? 0
                            : 1,
                    iCount: iCount || 0,
                    pCount: pCount || 0,
                    pType: 0,
                    nmPoints: nmPoints || 0,
                    qScore: qScore || 0,
                    dpID: dpId || 0,
                    rdsID: rdsId || 0,
                    rdsVer: rdsVer || 0,
                    dc: dc || 0,
                    mi: mi || 0,
                    mc: mc || 0,
                    ci: ci || 0,
                    sessionKey: xmltojson.PidData.Skey["#text"],
                    hmac: Hmac || 0,
                    PidDatatype: xmltojson.PidData.Data.type,
                    Piddata: xmltojson.PidData.Data["#text"],
                };

                const formdata = new FormData();
                Object.entries(payload).forEach(([k, v]) => formdata.append(k, v));

                // ================= TRANSACTION SWITCH =================
                if (type === "cw") {
                    return AepsCashWithdrawl(formdata);
                } else if (type === "ap") {
                    return AepsAadharpay(formdata);
                } else if (type === "be") {
                    return AepsBalanceEnquiry(formdata);
                }
                else if (type === "ms") {
                    return AepsMinistatement(formdata);
                }
                else {
                    return AepsCashDeposit(formdata);
                }
            })
            .then((res) => {
                if (!res) return;

                if (res.status_1 === false) {
                    navigate("/banking/aeps", {
                        state: { from: location.pathname, type },
                    });
                    return;
                }

                if (res.status) {
                    setResponse(res);
                    setOpenReceiptDrawer(true);
                    // setopentransactionModal(false);
                } else {
                    dispatchtoast(res.message ?? "Transaction failed", true);
                }
            })
            .catch((error) => {
                console.log(error);
                if (error?.response?.data?.status_1 === false) {
                    navigate("/banking/aeps", {
                        state: { from: location.pathname, type },
                    });
                }
            })
            .finally(() => setBtnLoading(false));
    };





    const handleSubmit = (values, type) => {
        if (fields === "morpho") {
            DeviceInfo((imei, index) => capture(imei, type, index, values), setBtnLoading);
        } else if (fields === "mantra") {
            MantradeviceInfoAvdm(
                (imei, port) => capture(imei, type, port, values),
                setBtnLoading
            );
        } else if (fields === "iris") {
            MantraIrisdeviceInfoAvdm(() => capture());
        } else if (fields === "startek") {
            StartekDeviceInfo(() => capture());
        }
    };
    const TabsData = [
        {
            key: "1",
            name: "Balance Enquiry",
            txn: "BE",

            component: (
                <div className="p-4 bg-white">
                    <p className="font-bold text-[15px] mb-2">AEPS-1 Transaction</p>
                    <Form
                        ref={formref}
                        form={form}
                        onFinish={(values) => { setFilledData(values); handleSubmit(values, "be") }}
                    >
                        <div className="grid grid-cols-1 place-items-center">
                            {/* <Form.Item
                className="w-full"
                name="iin"
                label="Bank Name"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select any one Bank!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select--"
                  showSearch
                  filterOption={filterOption}
                  className="w-full h-9"
                  options={banks}
                />
              </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="mobile"
                label="Mobile"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter mobile number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Please enter a valid mobile number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="aadhaar"
                label="Aadhaar Number"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter aadhar number!",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Please enter a valid aadhar number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="device"
                                label="Select Device"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select any one device!",
                                    },
                                ]}
                            >
                                <Select
                                    value={fields}
                                    filterOption={filterOption}
                                    placeholder="Select a device"
                                    onChange={(val) => setFields(val)}
                                    className="w-full mt-2"
                                    options={deviceOptions}
                                />
                            </Form.Item>
                        </div>

                        <div className="flex mt-4 justify-end items-center">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    disabled={!fields}
                                    htmlType="submit"
                                    className="bg-primary outline-none border-none text-white"
                                >
                                    Scan & Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            ),
        },
        {
            key: 2,
            name: "Cash Withdrawal",
            txn: "CW",

            component: (
                <div className="p-4 bg-white">
                    <p className="font-bold text-[15px] mb-2">AEPS-1 Transaction</p>
                    <Form
                        ref={formref}
                        form={form}
                        onFinish={(values) => { setFilledData(values); handleSubmit(values, "cw") }}
                    >
                        <div className="grid grid-cols-1 place-items-center">
                            {/* <Form.Item
                className="w-full"
                name="iin"
                label="Bank Name"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select any one Bank!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select--"
                  showSearch
                  filterOption={filterOption}
                  className="w-full h-9"
                  options={banks}
                />
              </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="mobile"
                label="Mobile"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter mobile number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Please enter a valid mobile number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="amount"
                                label="Amount"

                                rules={[
                                    {
                                        required: true,
                                        message: "Enter Amount",
                                    },
                                ]}
                                labelCol={{ span: 24 }}
                            >
                                <CommonInput onChange={(e) => setamount(e.target.value)} />
                            </Form.Item>

                            {/* <Form.Item
                className="w-full"
                name="aadhaar"
                label="Aadhaar Number"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter aadhar number!",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Please enter a valid aadhar number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="device"
                                label="Select Device"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select any one device!",
                                    },
                                ]}
                            >
                                <Select
                                    value={fields}
                                    filterOption={filterOption}
                                    placeholder="Select a device"
                                    onChange={(val) => setFields(val)}
                                    className="w-full mt-2"
                                    options={deviceOptions}
                                />
                            </Form.Item>
                        </div>

                        <div className="flex mt-4 justify-end items-center">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    disabled={!fields}
                                    htmlType="submit"
                                    className="bg-primary outline-none border-none text-white"
                                >
                                    Scan & Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            ),
        },
        {
            key: 3,
            name: "Cash Deposit",
            txn: "CD",

            component: (
                <div className="p-4 bg-white">
                    <p className="font-bold text-[15px] mb-2">AEPS-1 Transaction</p>
                    <Form
                        ref={formref}
                        form={form}
                        onFinish={(values) => { setFilledData(values); handleSubmit(values, "cd") }}
                    >
                        <div className="grid grid-cols-1 place-items-center">
                            {/* <Form.Item
                className="w-full"
                name="iin"
                label="Bank Name"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select any one Bank!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select--"
                  showSearch
                  filterOption={filterOption}
                  className="w-full h-9"
                  options={banks}
                />
              </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="mobile"
                label="Mobile"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter mobile number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Please enter a valid mobile number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="amount"
                                label="Amount"

                                rules={[
                                    {
                                        required: true,
                                        message: "Enter Amount",
                                    },
                                ]}
                                labelCol={{ span: 24 }}
                            >
                                <CommonInput onChange={(e) => setamount(e.target.value)} />
                            </Form.Item>

                            {/* <Form.Item
                className="w-full"
                name="aadhaar"
                label="Aadhaar Number"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter aadhar number!",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Please enter a valid aadhar number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="device"
                                label="Select Device"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select any one device!",
                                    },
                                ]}
                            >
                                <Select
                                    value={fields}
                                    filterOption={filterOption}
                                    placeholder="Select a device"
                                    onChange={(val) => setFields(val)}
                                    className="w-full mt-2"
                                    options={deviceOptions}
                                />
                            </Form.Item>
                        </div>

                        <div className="flex mt-4 justify-end items-center">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    disabled={!fields}
                                    htmlType="submit"
                                    className="bg-primary outline-none border-none text-white"
                                >
                                    Scan & Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            ),
        },
        {
            key: 4,
            name: "Mini Statement",
            txn: "MS",

            component: (
                <div className="p-4 bg-white">
                    <p className="font-bold text-[15px] mb-2">AEPS-1 Transaction</p>
                    <Form
                        ref={formref}
                        form={form}
                        onFinish={(values) => { setFilledData(values); handleSubmit(values, "ms") }}
                    >
                        <div className="grid grid-cols-1 place-items-center">
                            {/* <Form.Item
                className="w-full"
                name="iin"
                label="Bank Name"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select any one Bank!",
                  },
                ]}
              >
                <Select
                  placeholder="--Select--"
                  showSearch
                  filterOption={filterOption}
                  className="w-full h-9"
                  options={banks}
                />
              </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="mobile"
                label="Mobile"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter mobile number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Please enter a valid mobile number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            {/* <Form.Item
                  className="w-full"
                  name="txnType"
                  label="Transaction Type"
                  labelCol={{ span: 24 }}
                >
                  <Select
                    placeholder="--Select--"
                    showSearch
                    filterOption={filterOption}
                    onChange={(e) => setTxnType(e)}
                    className="w-full h-9"
                    options={[
                      { label: "Balance Enquiry", value: "BE" },
                      { label: "Cash Withdrawal", value: "CW" },
                      { label: "Cash Deposit", value: "CD" },
                      { label: "Mini Statement", value: "MS" },
                    ]}
                  />
                </Form.Item> */}

                            {/* <Form.Item
                className="w-full"
                name="aadhaar"
                label="Aadhaar Number"
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter aadhar number!",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Please enter a valid aadhar number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput />
              </Form.Item> */}

                            <Form.Item
                                className="w-full"
                                name="device"
                                label="Select Device"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select any one device!",
                                    },
                                ]}
                            >
                                <Select
                                    value={fields}
                                    filterOption={filterOption}
                                    placeholder="Select a device"
                                    onChange={(val) => setFields(val)}
                                    className="w-full mt-2"
                                    options={deviceOptions}
                                />
                            </Form.Item>
                        </div>

                        <div className="flex mt-4 justify-end items-center">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    disabled={!fields}
                                    htmlType="submit"
                                    className="bg-primary outline-none border-none text-white"
                                >
                                    Scan & Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            ),
        },
        {
            key: 5,
            name: "Aadhar Pay",
            txn: "ap",

            component: (
                <div className="p-4 bg-white">
                    <p className="font-bold text-[15px] mb-2">AEPS-1 Transaction</p>
                    <Form
                        ref={formref}
                        form={form}
                        onFinish={(values) => { setFilledData(values); handleSubmit(values, "ap") }}
                    >
                        <div className="grid grid-cols-1 place-items-center">
                            <Form.Item
                                className="w-full"
                                name="amount"
                                label="Amount"

                                rules={[
                                    {
                                        required: true,
                                        message: "Enter Amount",
                                    },
                                ]}
                                labelCol={{ span: 24 }}
                            >
                                <CommonInput onChange={(e) => setamount(e.target.value)} />
                            </Form.Item>

                            <Form.Item
                                className="w-full"
                                name="device"
                                label="Select Device"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Select any one device!",
                                    },
                                ]}
                            >
                                <Select
                                    value={fields}
                                    filterOption={filterOption}
                                    placeholder="Select a device"
                                    onChange={(val) => setFields(val)}
                                    className="w-full mt-2"
                                    options={deviceOptions}
                                />
                            </Form.Item>
                        </div>

                        <div className="flex mt-4 justify-end items-center">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    disabled={!fields}
                                    htmlType="submit"
                                    className="bg-primary outline-none border-none text-white"
                                >
                                    Scan & Submit
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            ),
        },
    ];

    const tab2 = [
        {
            key: 1,
            name: "detailPage",
            component: (
                <DetailPage
                    current={current}
                    banks={banks}
                    areDetailsPresent={setdetail}
                    setCurrent={setCurrent}
                />
            ),
        },
    ];
    const tabsToRender = (detail ? TabsData : tab2);
    const currentTab = TabsData.find((tab) => tab.key === activeTab);
    useEffect(() => {
        getLocalStorageItem("mobile_num");
        getLocalStorageItem("customer_aadhaar_number");
        getLocalStorageItem("user_bank_name");
    }, []);
    const userBankName = localStorage.getItem("user_bank_name");
    const customerAadhaarNumber = localStorage.getItem("customer_aadhaar_number");
    const mobileNum = localStorage.getItem("mobile_num");

    const handleLocalStorage = (val) => {
        // setbtn(true);
        setOpenModal(false);
        if (val.customer_mobile) {
            setLocalStorageItem("mobile_num", val.customer_mobile);
            setphoneno(val.customer_mobile);
        }
        if (val.customer_aadhaar_number) {
            setLocalStorageItem(
                "customer_aadhaar_number",
                val.customer_aadhaar_number
            );
            setadharno(val.customer_aadhaar_number);
        }
        if (val?.user_bank?.value) {
            setLocalStorageItem("user_bank_value", val?.user_bank?.value);
        }
        if (val.user_bank.label) {
            setLocalStorageItem("user_bank_name", val.user_bank.label);
            setbankname(val.user_bank.label);
        }
    };

console.log("  response?.data?.miniStatementData",  response?.data?.miniStatementData);

    const Content = () => {
        return (
            <>
                {txnType == "BE" ? (
                    <>
                        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
                            <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
                                Transaction I'd
                            </p>
                            <p className="text-[11px] mt-2 mb-2">{response?.transaction_id}</p>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Balance Amount</p>
                                <p className="text-black">{response?.amount} Rs.</p>
                            </div>
                        </div>
                        {/* <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
              <div className="flex justify-between items-center">
                <p>Merchant Name</p>
                <p className="text-black">{response?.merchant_name}</p>
              </div>
            </div> */}
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Bank Name</p>
                                <p style={{ wordBreak: "break-word" }} className="text-black">
                                    {response?.bank_name}
                                </p>
                            </div>
                        </div>
                        {/* <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                <div className="flex justify-between items-center">
                  <p>Bank RRN</p>
                  <p className="text-black">{response?.data?.rrn} Rs.</p>
                </div>
              </div> */}
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Aadhar Number</p>
                                <p className="text-black">{response?.masked_aadhaar}</p>
                            </div>
                        </div>
                    </>
                ) : txnType == "CW" ? (
                    <>
                        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
                            <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
                                Transaction I'd
                            </p>
                            <p className="text-[11px] mt-2 mb-2">
                                {response?.data?.merchantTransactionId}
                            </p>
                        </div>
                        {/* <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                <div className="flex justify-between items-center">
                  <p>Merchant Name</p>
                  <p className="text-black">{response?.data?.merchant_name}</p>
                </div>
              </div> */}
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Bank Name</p>
                                <p className="text-black">{response?.data?.bank_name}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Aadhar Number</p>
                                <p className="text-black">{response?.data?.masked_aadhaar}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Withdrawl Amount</p>
                                <p className="text-black">{filledData?.amount} Rs.</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Merchant Name</p>
                                <p className="text-black">{response?.data.merchant_name}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Remaining Balance</p>
                                <p className="text-black">
                                    {response?.data?.balanceAmount ?? "0"} Rs.
                                </p>
                            </div>
                        </div>

                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Bank RRN</p>
                                <p className="text-black">{response?.data?.rrn || "N/A"}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Status</p>
                                <p className="text-black">{response?.data?.status}</p>
                            </div>
                        </div>
                    </>
                ) : txnType == "CD" ? (
                    <>
                        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
                            <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
                                Transaction I'd
                            </p>
                            <p className="text-[11px] mt-2 mb-2">
                                {response?.merchantTransactionId}
                            </p>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Balance Amount</p>
                                <p className="text-black">{response?.balanceAmount || response?.amount} Rs.</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>RRN</p>
                                <p className="text-black">{response?.rrn}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Merchant Name</p>
                                <p className="text-black">{response?.merchant_name}</p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Bank Name</p>
                                <p style={{ wordBreak: "break-word" }} className="text-black">
                                    {response?.bank_name}
                                </p>
                            </div>
                        </div>
                        <div className="text-[10px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-400 mt-4 ">
                            <div className="flex justify-between items-center">
                                <p>Aadhar Number</p>
                                <p className="text-black">{response?.masked_aadhaar}</p>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="bg-white w-full mt-2 rounded-md p-4">
                            <div className="font-semibold text-xs">
                                <p>Balance : {response?.data.balanceAmount ?? 0} Rs</p>
                                <p>Merchant Name : {response?.data.merchant_name ?? "-"}</p>
                                <p>Bank Name : {response?.data.bank_name ?? "-"}</p>
                                <p>Aadhar Number : {response?.data.masked_aadhaar ?? "-"}</p>
                                <p>Transaction I'd: {response?.data.merchantTxnId ?? "-"}</p>
                                <p>Bank RRN: {response?.data.bankRRN}</p>
                            </div>
                        </div>
                        <div className="bg-white w-full  p-4 rounded-md">
                            <p className="font-bold">Statements</p>
                            {Array.isArray(response?.data?.miniStatementData) &&
                                response?.data?.miniStatementData.map((i, index) => {
                                    return (
                                        <>
                                            <div className="mt-4">
                                                <p className="text-xs">{i?.narration}</p>
                                                <div className="flex justify-between items-center mt-2">
                                                    <p className="font-semibold text-xs">
                                                        Amount: {i.amount} Rs.
                                                    </p>
                                                    <p
                                                        className={`${i?.txnType === "Dr"
                                                            ? "text-red-600"
                                                            : "text-green-500"
                                                            }  font-bold`}
                                                    >
                                                        {i.txnType}.
                                                    </p>
                                                </div>
                                                <p className="font-semibold text-xs">Date: {i?.date}</p>
                                            </div>
                                            <hr className="mt-2" />
                                        </>
                                    );
                                })}
                        </div>
                    </>
                )}
            </>
        );
    };
    return (
        <>
            {detail && (
                <div className="bg-white shadow-lg rounded-xl p-6 w-full flex md:flex-row flex-col mb-6   h-auto items-center justify-between">
                    {/* Details Section */}
                    <div className="flex md:flex-row flex-col md:items-center items-start md:gap-32 gap-10 w-full">
                        {/* Mobile No */}
                        <div className="flex items-center gap-3">
                            <div className="p-3 border-[1px] text-[#6b7280] border-[#6b7280]  border-solid rounded-[50%]">
                                <FaPhone />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Mobile No.</p>
                                <p className="text-gray-900 font-semibold">
                                    {JSON.parse(mobileNum)}
                                </p>
                            </div>
                        </div>

                        {/* Aadhar No */}
                        <div className="flex items-center gap-3">
                            <div className="p-3 border-[1px] text-[#6b7280] border-[#6b7280]  border-solid rounded-[50%]">
                                <FaMoneyCheck />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Aadhar No.</p>
                                <p className="text-gray-900 font-semibold">
                                    {JSON.parse(customerAadhaarNumber)}
                                </p>
                            </div>
                        </div>

                        {/* Bank Name */}
                        <div className="flex items-center gap-3">
                            <div className="p-3 border-[1px] text-[#6b7280] border-[#6b7280]  border-solid rounded-[50%]">
                                <FaBuilding />
                            </div>
                            <div>
                                <p className="text-sm text-gray-500">Bank Name</p>
                                <p className="text-gray-900 font-semibold">
                                    {JSON.parse(userBankName)}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Edit Button */}
                    <div>
                        <button
                            style={{ background: "var(--primary)" }}
                            onClick={() => setOpenModal(true)}
                            className="flex items-center gap-2 bg-blue-500 text-white px-2 text-sm py-1 rounded-lg shadow-lg hover:bg-blue-600 transition"
                        >
                            <EditOutlined /> <span>Edit</span>
                        </button>
                    </div>
                </div>
            )}
            <div className="mt-2 bg-white rounded-lg grid grid-cols-1 md:grid-cols-5 place-items-start md:place-items-center gap-y-4">
                {
                    detail &&
                    TabsData.map((tab) => (
                        <div key={tab.key} className="w-full text-center">
                            <p
                                onClick={() => {
                                    setActiveTab(tab.key);
                                    setTxnType(tab.txn);
                                }}
                                className={`cursor-pointer transition-all  ${activeTab === tab.key
                                    ? "bg-primary tab-active text-white"
                                    : "border border-[#EBEBEB]"
                                    }  py-2 `}
                            >
                                {tab.name}
                            </p>
                        </div>
                    ))}
            </div>

            <div className="mt-4 w-full md:w-1/2 rounded-md">
                {detail ? (
                    tabsToRender
                        .filter((tab) => tab.key === activeTab)
                        .map((tab) => <div key={tab.key}>{tab.component}</div>)
                ) : (
                    // directly render tab2’s only component
                    <div key={tab2[0].key}>{tab2[0].component}</div>
                )}
            </div>
            <Modal
                maskClosable={false}
                open={OpenModal}
                footer={null}
                onCancel={() => setOpenModal(false)}
            >
                <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
                    <div className="prepaid  w-full bg-white shadow-normal rounded-3xl p-5">
                        <p className="font-bold text-[15px] mb-2">
                            Fill all the Required details
                        </p>
                        <Form
                            name="basic"
                            form={formModal}
                            ref={formrefModal}
                            initialValues={{
                                remember: true,
                            }}
                            onFinishFailed={(err) => console.log(err)}
                            onFinish={(val) => handleLocalStorage(val)}
                        >
                            <Form.Item
                                name={`customer_mobile`}
                                label={"Mobile Number"}
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required:
                                            phoneno || getLocalStorageItem("mobile_num")
                                                ? false
                                                : true,
                                        message: "Enter Mobile Number!",
                                    },
                                    {
                                        pattern: mobilePattern,
                                        message: "Invalid mobile number format!",
                                    },
                                    {
                                        whitespace: true,
                                        message: "Field cannot contain only blank spaces",
                                    },
                                ]}
                            >
                                <CommonInput
                                    placeholder="Enter Your Mobile Number"
                                    defaultValue={getLocalStorageItem("mobile_num")}
                                    onInput={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        e.target.value = value;
                                    }}
                                    name="customer_mobile"
                                />
                            </Form.Item>
                            <Form.Item
                                name={`customer_aadhaar_number`}
                                label={"Aadhar Number"}
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required:
                                            adharno || getLocalStorageItem("customer_aadhaar_number")
                                                ? false
                                                : true,
                                        message: "Enter aadhar Number!",
                                    },
                                    {
                                        pattern: aadharPattern,
                                        message: "Invalid aadhar number format!",
                                    },
                                    {
                                        whitespace: true,
                                        message: "Field cannot contain only blank spaces",
                                    },
                                ]}
                            >
                                <CommonInput
                                    defaultValue={getLocalStorageItem("customer_aadhaar_number")}
                                    onInput={(e) => {
                                        const value = e.target.value.replace(/\D/g, "");
                                        e.target.value = value;
                                    }}
                                    placeholder="Enter Aadhar Number"
                                    name="customer_aadhaar_number"
                                />
                            </Form.Item>{" "}
                            <Form.Item
                                name={`user_bank`}
                                label={"Select Bank"}
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required:
                                            getLocalStorageItem("user_bank_value") && userBankName
                                                ? false
                                                : true,
                                        message: "Select one bank!",
                                    },
                                ]}
                            >
                                <Select
                                    showSearch
                                    labelInValue={true}
                                    defaultValue={
                                        getLocalStorageItem("user_bank_name") == null
                                            ? ""
                                            : getLocalStorageItem("user_bank_name")
                                    }
                                    placeholder="Select a bank"
                                    filterOption={filterOption}
                                    className="w-full"
                                    options={banks}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    htmlType="submit"
                                    style={{ color: "white", background: "var(--primary)" }}
                                    className="bg-primary w-[100%] outline-none border-none text-white"
                                >
                                    Save
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Modal>

            {/* <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full md:w-1/2  shadow-normal  rounded-3xl p-5">
          <div className="selectionFields">
            <Tabs
              className="custom-tabs"
              defaultActiveKey="1"
              type="card"
              items={tabItems}
            />
          </div>
        </div>
      </div> */}
            {openReceiptDrawer && (
                <ReportDrawer
                    title={
                        txnType == "BE"
                            ? "Balance Receipt"
                            : txnType == "CW"
                                ? "Cash Withdrawl Receipt"
                                : txnType == "CD"
                                    ? "Cash Deposit Receipt"
                                    : "Mini Statement"
                    }
                    open={openReceiptDrawer}
                    setOpen={setOpenReceiptDrawer}
                    content={<Content />}
                />
            )}
        </>
    );
};

export default AllInOne;
